import ReportsIndex from '../../Reports/index'
import { connect } from 'react-redux'
import { getYear } from '../../TPODashboard/action'

const mapStateToProps = state => ({})

const mapDispatchToProps = {
  getYear,
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportsIndex)
